import styled from 'styled-components';
import Theme from '../../../styles/models/theme';

export const Text = styled.h1<{theme?: Theme; type: string}>`
  color: ${({theme}) => theme.darkText};
  font-size: 16px;
  font-weight: ${({type}) => type};
`;
